<div class="header top-0 w-full sticky">
    <div class="wrapper relative mx-auto">
        <header class="flex justify-end relative">
            <!-- Nav menu -->
            <nav [ngClass]="{ open: isMenuOpen }" class="flex flex-col max-h-[885px]">
                <div class="pt-7 px-11 logo bg-grey-chateau">
                    <a routerLink="/"><img src="img/nav-logo.svg" alt="" /></a>
                </div>
                <!-- Nav list -->
                <ul class="menu-list overflow-y-scroll">
                    <p-panelMenu [model]="menuList">
                        <ng-template #item let-item>
                            @if (item.route) {
                                <a
                                    [routerLink]="item.route"
                                    (click)="openMenu()"
                                    routerLinkActive="active-sublink"
                                    class="flex items-center cursor-pointer px-6 py-2 sublink text-lg"
                                >
                                    <span [class]="item.icon"></span>
                                    <span class="ml-2">{{ item.label }}</span>
                                </a>
                            } @else {
                                <span class="flex items-center cursor-pointer px-6 py-2 text-lg">
                                    <span [class]="item.icon"></span>
                                    <span class="ml-2">{{ item.label }}</span>
                                    @if (item.badge) {
                                        <p-badge severity="success" class="ml-2" [value]="item.badge" />
                                    }
                                    @if (item.items) {
                                        <i class="pi pi-angle-down text-primary ml-auto"></i>
                                    }
                                </span>
                            }
                            <ng-template #urlRef>
                                <!-- <a
                *ngIf="item.url; else noLink"
                [href]="item.url"
                class="flex items-center cursor-pointer px-3 py-2"
                >
                <span [class]="item.icon"></span>
                <span class="ml-5">{{ item.label }}</span>
                <p-badge
                  *ngIf="item.badge"
                  class="ml-auto"
                  [value]="item.badge"
                  />
                </a> -->
                            </ng-template>
                        </ng-template>
                    </p-panelMenu>
                </ul>
                <p class="menu-copyright mt-auto">© Copyright 2024 <span>news</span></p>
            </nav>
            <div class="text-white flex justify-between header-info w-full items-center">
                <!-- Header title -->
                <div class="flex flex-col justify-end header-title">
                    <h1 class="sm:text-inherit text-xl!">{{ title }}</h1>
                    <p class="sm:text-inherit !text-md">{{ subtitle }} <span></span></p>
                </div>
                <!-- Header profile -->
                <div class="flex items-center gap-3">
                    <div class="flex-col items-end sm:flex hidden">
                        <div>
                            <h5 class="font-bold sm:text-[20px] text-base text-end">
                                {{ activeUser?.data?.first_name + " " + activeUser?.data?.last_name }}
                            </h5>
                        </div>
                        <div>
                            <p class="font-medium sm:text-base text-sm">{{ roleName }}</p>
                        </div>
                    </div>
                    <p-button (click)="op.toggle($event)" [text]="true" class="profile-btn">
                        <!-- <svg
            class="cursor-pointer"
            width="43"
            height="40"
            viewBox="0 0 41 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
              d="M20.5 0C9.46 0 0.5 8.96 0.5 20C0.5 31.04 9.46 40 20.5 40C31.54 40 40.5 31.04 40.5 20C40.5 8.96 31.54 0 20.5 0ZM11.2 33C13.82 31.12 17.02 30 20.5 30C23.98 30 27.18 31.12 29.8 33C27.18 34.88 23.98 36 20.5 36C17.02 36 13.82 34.88 11.2 33ZM32.78 30.24C29.4 27.6 25.14 26 20.5 26C15.86 26 11.6 27.6 8.22 30.24C5.9 27.46 4.5 23.9 4.5 20C4.5 11.16 11.66 4 20.5 4C29.34 4 36.5 11.16 36.5 20C36.5 23.9 35.1 27.46 32.78 30.24Z"
              fill="white"
              />
              <path
                d="M20.5 8C16.64 8 13.5 11.14 13.5 15C13.5 18.86 16.64 22 20.5 22C24.36 22 27.5 18.86 27.5 15C27.5 11.14 24.36 8 20.5 8ZM20.5 18C18.84 18 17.5 16.66 17.5 15C17.5 13.34 18.84 12 20.5 12C22.16 12 23.5 13.34 23.5 15C23.5 16.66 22.16 18 20.5 18Z"
                fill="white"
                />
              </svg> -->
                        <div class="image-user relative">
                            <span class="uppercase"
                                >{{ activeUser?.data?.first_name | slice: 0 : 1
                                }}{{ activeUser?.data?.last_name | slice: 0 : 1 }}</span
                            >
                            <p-popover #op styleClass="profile-popover">
                                <div class="flex flex-col gap-2">
                                    <p-button
                                        *appHasPermission="'view_profile'"
                                        severity="info"
                                        label="Pregledaj profil"
                                        (onClick)="onViewProfile()"
                                        variant="outlined"
                                        icon="pi pi-user"
                                    ></p-button>

                                    <p-button
                                        *appHasPermission="'update_profile'"
                                        severity="info"
                                        label="Izmjeni profil"
                                        [routerLink]="['me-add-edit', activeUser?.data?.id]"
                                        icon="pi pi-cog"
                                        variant="outlined"
                                        styleClass="w-full"
                                    ></p-button>

                                    <p-button
                                        severity="danger"
                                        label="Odjavi se"
                                        (click)="onLogout()"
                                        styleClass="w-full"
                                        variant="outlined"
                                    ></p-button>
                                </div>
                            </p-popover>
                        </div>
                    </p-button>

                    <!-- Hamburger menu -->
                    <div (click)="openMenu()" class="z-50 cursor-pointer ms-auto hamburger">
                        <svg
                            [ngClass]="isMenuOpen ? 'active' : ''"
                            class="ham hamRotate ham4"
                            viewBox="0 0 100 100"
                            width="60"
                            fill=""
                        >
                            <path
                                class="line top"
                                d="m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5 0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20"
                            />
                            <path class="line middle" d="m 70,50 h -40" />
                            <path
                                class="line bottom"
                                d="m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5 0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20"
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </header>
    </div>
</div>
<div
    [ngClass]="{ 'overlay-show': isMenuOpen }"
    class="h-screen fixed top-0 left-full right-0 z-30 transition-left duration-500"
    (click)="openMenu()"
></div>
